import { TypeRibbonFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import Ribbon from './Ribbon'

const ContentfulRibbon = withContentful<TypeRibbonFields>(Ribbon)

export default ContentfulRibbon
